class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
    
    // Mover el selector de idioma con un pequeño retraso para asegurar que todo está cargado
    setTimeout(() => {
      this.moveLanguageSelector();
    }, 500);
  }
  
  // Función para mover el selector de idioma desde el footer al bloque "Conecta con nosotros"
  moveLanguageSelector() {
    // Obtener el selector de idioma original
    const originalSelector = document.querySelector('.m-footer--bottom .m-footer--currency-language .m-switcher-dropdown');
    
    if (!originalSelector) {
      return;
    }
    
    // Obtener el contenedor de redes sociales
    const socialMediaContainer = document.querySelector('.m-footer--block-our_store .social-media-links');
    
    if (!socialMediaContainer) {
      return;
    }
    
    // Crear un nuevo contenedor para el selector de idioma
    const languageContainer = document.createElement('div');
    languageContainer.className = 'language-selector-container';
    
    // Clonar el selector original y añadirlo al nuevo contenedor
    const clonedSelector = originalSelector.cloneNode(true);
    languageContainer.appendChild(clonedSelector);
    
    // Insertar el nuevo contenedor después de las redes sociales
    socialMediaContainer.parentNode.insertBefore(languageContainer, socialMediaContainer.nextSibling);
    
    // Asegurarnos de que el selector clonado tiene todos los eventos necesarios
    const clonedForm = clonedSelector.querySelector('form');
    const clonedSelect = clonedSelector.querySelector('select');
    
    if (clonedForm && clonedSelect) {
      // Asegurar que el select cambia el valor correcto en el formulario
      clonedSelect.addEventListener('change', function() {
        // Encontrar el input hidden para el código de locale
        const localeInput = clonedForm.querySelector('input[data-localization-input]');
        if (localeInput) {
          localeInput.value = this.value;
        }
        
        // Enviar el formulario para cambiar el idioma
        clonedForm.submit();
      });
      
      // Para el selector personalizado si existe
      const customSelect = clonedSelector.querySelector('.m-select-custom');
      if (customSelect) {
        const customTrigger = customSelect.querySelector('.m-select-custom--trigger');
        const customOptions = customSelect.querySelector('.m-select-custom--options');
        
        if (customTrigger && customOptions) {
          // Mostrar/ocultar opciones al hacer clic en el trigger
          customTrigger.addEventListener('click', function(e) {
            e.stopPropagation();
            customOptions.classList.toggle('visible');
            
            // Añadir estilo para que las opciones sean visibles
            if (customOptions.classList.contains('visible')) {
              customOptions.style.display = 'block';
            } else {
              customOptions.style.display = 'none';
            }
          });
          
          // Manejar el clic en las opciones
          const options = customOptions.querySelectorAll('.m-select-custom--option');
          options.forEach(option => {
            option.addEventListener('click', function(e) {
              e.stopPropagation();
              
              // Obtener el valor de la opción seleccionada
              const value = this.getAttribute('data-value');
              
              // Actualizar el texto mostrado
              const triggerText = customTrigger.querySelector('.m-select-custom--trigger-text');
              if (triggerText) {
                triggerText.textContent = this.textContent;
              }
              
              // Actualizar el select nativo
              if (clonedSelect) {
                clonedSelect.value = value;
                
                // Disparar evento change para activar listeners
                const event = new Event('change', { bubbles: true });
                clonedSelect.dispatchEvent(event);
              }
              
              // Ocultar opciones
              customOptions.classList.remove('visible');
              customOptions.style.display = 'none';
            });
          });
          
          // Cerrar al hacer clic fuera
          document.addEventListener('click', function() {
            customOptions.classList.remove('visible');
            customOptions.style.display = 'none';
          });
        }
      }
    }
  }
}
customElements.define("m-footer", MFooter);
